import axiosInstance from "./axiosInstance";

// Get all links
export const getLinks = async (category) => {
  // const res = await axiosInstance.get("/links");
  const res = await axiosInstance.get(`/links${category ? `?category=${category}` : ""}`);
  return res.data.links;
};

// Get a single link by ID
export const getLinkById = async (id) => {
  const res = await axiosInstance.get(`/links/${id}`);
  return res.data.link;
};

// Create a new external link
export const createLink = async (linkData) => {
  const res = await axiosInstance.post("/links", linkData);
  return res.data.link;
};

// Update a link by ID
export const updateLink = async (id, linkData) => {
  const res = await axiosInstance.put(`/links/${id}`, linkData);
  return res.data.link;
};

// Delete a link by ID
export const deleteLink = async (id) => {
  const res = await axiosInstance.delete(`/links/${id}`);
  return res.data;
};